// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
import { ContactsProposalFragmentDoc } from '../Contacts/Contacts.generated-types';
import { OptionalExtrasProposalFragmentDoc } from './OptionalExtras/OptionalExtras.generated-types';
import { UseDateTimeDurationProposalFragmentDoc } from '../../../Hooks/useDateTimeDuration/useDateTimeDuration.generated-types';
export type DetailsCardProposalFragment = { __typename?: 'Proposal', ID: number, attendees: number, baseCostDescription: string, baseCostTotal: number, currency: string, fromDateTime: string, toDateTime: string, extraCostItems?: Array<{ __typename?: 'ExtraCostItem', ID: number, costPerUnit: number, description: string }> | null, space: { __typename?: 'SelfServeSpace', hostContact: { __typename?: 'HostContact', email?: string | null, phoneNumber?: string | null }, venue?: { __typename?: 'SelfServeVenue', name?: string | null } | null } };

export const DetailsCardProposalFragmentDoc = gql`
    fragment DetailsCardProposal on Proposal {
  ID
  attendees
  baseCostDescription
  baseCostTotal
  extraCostItems {
    ID
    costPerUnit
  }
  currency
  ...ContactsProposal
  ...OptionalExtrasProposal
  ...UseDateTimeDurationProposal
}
    ${ContactsProposalFragmentDoc}
${OptionalExtrasProposalFragmentDoc}
${UseDateTimeDurationProposalFragmentDoc}`;